import { render, staticRenderFns } from "./switchNotice.vue?vue&type=template&id=21579162&scoped=true&lang=html&"
import script from "./switchNotice.vue?vue&type=script&lang=js&"
export * from "./switchNotice.vue?vue&type=script&lang=js&"
import style0 from "./switchNotice.vue?vue&type=style&index=0&id=21579162&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21579162",
  null
  
)

component.options.__file = "switchNotice.vue"
export default component.exports